export default "__VITE_ASSET__oGuh7oxb__"